import { Router } from './core/router.js';
import { auth } from './core/auth.js';
import { applyTheme, loadTheme } from './core/theme.js';
import { AppShell } from './components/AppShell.js';
import { LoginView } from './views/LoginView.js';
import { RoleSelectView } from './views/RoleSelectView.js';
import { PropertiesView } from './views/PropertiesView.js';
import { PropertyView } from './views/PropertyView.js';
import { ContractsView } from './views/ContractsView.js';
import { ContractView } from './views/ContractView.js';
import { NewContractView } from './views/NewContractView.js';
import { MeView } from './views/MeView.js';
import { TasksView } from './views/TasksView.js';
import { InviteView } from './views/InviteView.js';
import { PublicPropertyView } from './views/PublicPropertyView.js';
import { PropertySheetView } from './views/PropertySheetView.js';
import { DocumentView } from './views/DocumentView.js';
import { AgencyView } from './views/AgencyView.js';
import { RequirementTemplatesView } from './views/RequirementTemplatesView.js';
import { RequirementTemplateEditView } from './views/RequirementTemplateEditView.js';
import { PropertyRequirementsView } from './views/PropertyRequirementsView.js';
import { NotificationsView } from './views/NotificationsView.js';
import { DashboardView } from './views/DashboardView.js';
import { InquiryView } from './views/InquiryView.js';
import { LandlordInquiriesView } from './views/LandlordInquiriesView.js';
import { AdminView } from './views/admin/AdminView.js';

applyTheme(loadTheme());

const root = document.getElementById('app');
const shell = new AppShell(root);
shell.mount();

const PUBLIC_PATHS = ['/login', '/admin'];

const isPublic = (path) => PUBLIC_PATHS.includes(path);

const router = new Router({
  outlet: shell.outlet,
  routes: [
    { path: '/',                   component: () => new AdminView() },
    { path: '/login',              component: () => new LoginView() },
    { path: '/admin',            component: () => new AdminView() },
  ],
  guard: (route, ctx) => {
    if (ctx.path === '/login') return null;
    if (!auth.isAuthenticated) return '/login';
    return null;
  },
});

router.onChange((ctx) => shell.setActiveTab(ctx.path));
auth.subscribe(() => router._resolve());
router.start();

// Bridge "/" to the right place after the router has booted.
function redirect() {
  return {
    render() {
      const path = auth.user?.roles?.includes('ADMIN') ? '/admin' : auth.defaultPath();
      window.location.hash = '#' + path;
      return document.createElement('div');
    },
    destroy() {},
  };
}
